// import lap1 from "../../assets/iphone.jpg";
// import lap2 from "../../assets/ewce.jpg";
// import lap3 from "../../assets/ecom.jpg";
// import lap4 from "../../assets/traf.jpg";
// import lap5 from "../../assets/you.jpg";
// import lap6 from "../../assets/smart.jpg";
// import lap7 from "../../assets/farekart.jpg";
// import lap8 from "../../assets/giftify.jpg";
// import lap9 from "../../assets/folio.jpg"



export const lapdet = [
    {
        img: 'https://ik.imagekit.io/35sznjvlf/assets/iphone.jpg?updatedAt=1719467668405',
        url: 'https://iphonewebsitecloneyathishshettigar.netlify.app/',
        heading:'iPhone 15 Pro',
        brief:"Developed an iPhone 15 Pro website clone with minimalistic, interactive animations and designs, mirroring Apple's style. Utilized GSAP for animations and Three.js to insert a 3D iPhone model, allowing users to change its color and view the results. Implemented Sentry to measure click rates, track errors, and assess user engagement and success rates."
    },
    {
        img: 'https://ik.imagekit.io/35sznjvlf/assets/folio.jpg?updatedAt=1719465265220',
        url: 'https://yathishshettigar.netlify.app',
        heading:'Personal Portfolio',
        brief:" Fully responsive and functional website using HTML, CSS, JavaScript. Implemented Web3Forms - Using this users can directly send message / queries to me without leaving the website or any third-party app like gmail."
    },

    {
        img: 'https://ik.imagekit.io/35sznjvlf/assets/ewce.jpg?updatedAt=1719467910562',
        url: 'https://ewcedummycollegewebsite.netlify.app/',
        heading:'Educity - EWCE',
        brief:"This is a complete responsive website using CSS media queries. Minimalistic and engaging hover effects. Web3Forms for user queries and feedback. Testimonials section to build user trust."
    },
    {
        img: 'https://ik.imagekit.io/35sznjvlf/assets/ecom.jpg?updatedAt=1719465261479',
        url: 'https://github.com/yathish1204/ecommerceShopOnline.git',
        heading:'e-commerce: Online cloth Store',
        brief:" This project is developed using MERN stack.Where I gave more importance to user authentication, Cart features, Login validation etc. User can buy things according to category."
    },
    {
        img: 'https://ik.imagekit.io/35sznjvlf/assets/farekart.jpg?updatedAt=1719465264434',
        url: 'https://www.figma.com/proto/L3SltfDtbZluSQQZuZ4rFo/Final-Assignment?node-id=8-89&t=qlCJiNNsanr5Sty1-1&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=8%3A3',
        heading:'Farekart - Grocery at your door step',
        brief:" It was my final project in Tutedudes UI/UX designing course. Where I tried to create User interface as user friendly as possible by keeping users problem at a center. Used some of figma's advanced concepts like Variables and Advance prototype using conditional statements etc."
    },
    {
        img:'https://ik.imagekit.io/35sznjvlf/assets/giftify.jpg?updatedAt=1719465266362',
        url: 'https://www.figma.com/proto/Nw6kI3CUZDnsupmBuLwYnm/tssTechnologies?node-id=0-1&t=VV7inSzXq8mCPRMz-1',
        heading:'Giftify - Gifting App',
        brief:"Designed Giftify, a user-centered gifting app focusing on user experience with interactive and easy-to-use login input forms. Features include a simple homepage and gift page for adding/removing products and generating a bill summary. Provides a seamless payment process with a confirmation gif and notification bar."
    },

    {
        img:'https://ik.imagekit.io/35sznjvlf/assets/traf.jpg?updatedAt=1719465283780',
        url: 'https://traffic-density-predictor.streamlit.app/',
        heading:'Traffic Desity Predictor',
        brief:"It's build using machine learning algorithm - Where we used XG boost algorithm instead of random forest theory and to fetch Real time traffic data we  used Google maps Apis."
    },

    {
        img: 'https://ik.imagekit.io/35sznjvlf/assets/you.jpg?updatedAt=1719465298895',
        url: 'https://vidtubeadfreestreaming.netlify.app/',
        heading:'VidTube - Premium streaming',
        brief:"Front end tools used : HTML , CSS , JavaScript. User can browse the videos category wise and Responsive navbar , sidebar. Data is fetched from YouTubes Data V3 API"
    },
 
   
    
    {
        img:'https://ik.imagekit.io/35sznjvlf/assets/smart.jpg?updatedAt=1719465282013',
        url: 'https://smartquizzappyathish.netlify.app/',
        heading:'SmartQuizz - Website',
        brief:"Designed a smart quiz website using ReactJS and Bootstrap, where users choose from four options, get immediate validation, and move to the next question. The total score is calculated dynamically."
    },
 
    
]